import { mapGetters, mapState } from 'vuex'

import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import toString from 'lodash/toString'
import str_is from 'str-is'

export default
{
	computed:
	{
		...mapState
		({
			contactMethodTypes: state => state.ccdb.contactMethodTypes,
			contactTypes:       state => state.ccdb.contactTypes,
		}),

		...mapGetters
		([
			'contact',
			'contactFullName',
			'contactMethods',
			'contactOrderId',
			'contactType',
			'detailsId',
			'hasContact',
			'isOrderContact',
		]),

		isCreate()
		{
			return this.isRoute('*.create')
		},

		isProfile()
		{
			return this.isRoute('profile.*')
		},

		hasContactMethods()
		{
			return !isEmpty(this.contactMethods)
		},

		groupedContactMethods()
		{
			return map(groupBy(this.contactMethods, 'type.label'), (options,label) => ({ label, options: options.filter(option => !isEmpty(option?.value)) }))
		},

		groupedEmailContactMethods()
		{
			return filter
			(
				this.groupedContactMethods,
				({ label, options }) => str_is('*email*', toString(label).toLowerCase())
			)
		},

		labelContactSelectOption(contact)
		{
			return [
				[ contact?.first_name, contact?.last_name ].filter(Boolean).join(' '),
				contact?.primaryEmail,
			].filter(Boolean).join(' - ')
		},
	},
}